import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';
import { createEntity, getEntity, reset, updateEntity } from './provision-of-unpaid-care.reducer';

export const ProvisionOfUnpaidCareUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const provisionOfUnpaidCareEntity = useAppSelector(state => state.provisionOfUnpaidCare.entity);
  const loading = useAppSelector(state => state.provisionOfUnpaidCare.loading);
  const updating = useAppSelector(state => state.provisionOfUnpaidCare.updating);
  const updateSuccess = useAppSelector(state => state.provisionOfUnpaidCare.updateSuccess);
  const geographicLevelValues = Object.keys(GeographicLevel);

  const handleClose = () => {
    navigate(`/provision-of-unpaid-care${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.totalAllUsualResidents !== undefined && typeof values.totalAllUsualResidents !== 'number') {
      values.totalAllUsualResidents = Number(values.totalAllUsualResidents);
    }
    if (values.providesNoCare !== undefined && typeof values.providesNoCare !== 'number') {
      values.providesNoCare = Number(values.providesNoCare);
    }
    if (values.provides1To19Hours !== undefined && typeof values.provides1To19Hours !== 'number') {
      values.provides1To19Hours = Number(values.provides1To19Hours);
    }
    if (values.provides20To49Hours !== undefined && typeof values.provides20To49Hours !== 'number') {
      values.provides20To49Hours = Number(values.provides20To49Hours);
    }
    if (values.provides50OrMoreHours !== undefined && typeof values.provides50OrMoreHours !== 'number') {
      values.provides50OrMoreHours = Number(values.provides50OrMoreHours);
    }

    const entity = {
      ...provisionOfUnpaidCareEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          geographicLevel: 'EXTRA_WARD',
          ...provisionOfUnpaidCareEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="apiLocationApp.provisionOfUnpaidCare.home.createOrEditLabel" data-cy="ProvisionOfUnpaidCareCreateUpdateHeading">
            <Translate contentKey="apiLocationApp.provisionOfUnpaidCare.home.createOrEditLabel">
              Create or edit a ProvisionOfUnpaidCare
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="provision-of-unpaid-care-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('apiLocationApp.provisionOfUnpaidCare.geographicLevel')}
                id="provision-of-unpaid-care-geographicLevel"
                name="geographicLevel"
                data-cy="geographicLevel"
                type="select"
              >
                {geographicLevelValues.map(geographicLevel => (
                  <option value={geographicLevel} key={geographicLevel}>
                    {translate(`apiLocationApp.GeographicLevel.${geographicLevel}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('apiLocationApp.provisionOfUnpaidCare.date')}
                id="provision-of-unpaid-care-date"
                name="date"
                data-cy="date"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.provisionOfUnpaidCare.geography')}
                id="provision-of-unpaid-care-geography"
                name="geography"
                data-cy="geography"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.provisionOfUnpaidCare.geographyCode')}
                id="provision-of-unpaid-care-geographyCode"
                name="geographyCode"
                data-cy="geographyCode"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.provisionOfUnpaidCare.totalAllUsualResidents')}
                id="provision-of-unpaid-care-totalAllUsualResidents"
                name="totalAllUsualResidents"
                data-cy="totalAllUsualResidents"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.provisionOfUnpaidCare.providesNoCare')}
                id="provision-of-unpaid-care-providesNoCare"
                name="providesNoCare"
                data-cy="providesNoCare"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.provisionOfUnpaidCare.provides1To19Hours')}
                id="provision-of-unpaid-care-provides1To19Hours"
                name="provides1To19Hours"
                data-cy="provides1To19Hours"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.provisionOfUnpaidCare.provides20To49Hours')}
                id="provision-of-unpaid-care-provides20To49Hours"
                name="provides20To49Hours"
                data-cy="provides20To49Hours"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.provisionOfUnpaidCare.provides50OrMoreHours')}
                id="provision-of-unpaid-care-provides50OrMoreHours"
                name="provides50OrMoreHours"
                data-cy="provides50OrMoreHours"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/provision-of-unpaid-care" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ProvisionOfUnpaidCareUpdate;
